import Panel, { PanelBody } from '../../../components/Panel'
import useInitial from './useInitial'
import Initial from '../../../components/Initial'
import Filters from './Filters'
import TableCategories from './Table'

export default function Stowage() {
    const state = useInitial()

    return (
        <Initial pageState={state}>
            <Panel>
                <PanelBody>
                    <Filters />
                    <TableCategories />
                </PanelBody>
            </Panel>
        </Initial>
    )
}
